import React from "react";

import Framework from "@beardeddevops/react.framework";
import {Types} from "components";
import ObjectOverride from "components/ObjectOverride";

class SendToKioskObject extends ObjectOverride {
	constructor(props) {
		super(props, Types.Dispositions_Pendings._name);
		this.update = 'POST_KIOSK';
	}

	// noinspection JSUnusedLocalSymbols
	handleProcess(event, requestOverride) {
		return true;
	}

	form = () => {
		/** @type {Dispositions_Pendings_Properties} properties */
		let properties = this.model.properties;
		/** @type {Dispositions_Pendings_Object} object */
		let object = this.state;
		let {loading} = this.state;

		return (
			<div>
				<fieldset>
					<div className="form-group">
						<div className={'form-group'}>
							<div className="row">
								<div className="col-4">
									<span className="input-label">Kiosk</span>
								</div>
								<div className={'col-8'}>
									<Framework.Elements.Select
										shouldLoad={true}
										update={this.handleSelectPropertyUpdate}
										objects={this.props.kiosks}
										property={properties.kiosk}
										value={object.kiosk}
										binary_id={object.kiosk_binary_id}
										error={object.kiosk_error}
										object={object.kiosks}
										text={'name'}
										nullable={false}
									/>
								</div>
							</div>
						</div>
					</div>

				</fieldset>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	}

}

export default Framework.Components.withRootState(SendToKioskObject);
